export default "__VITE_ASSET__C29STPyu__"